// extracted by mini-css-extract-plugin
export default {"container":"KA700","text":"GDJiX","sup":"xHOJC","grow":"XT5Cs","down":"Ih9VB"};